import React from 'react';
import { supabase } from '../../supabaseClient';
import { useSession } from '../../lib/SessionContext';
import { t } from '../../i18n';
import { Input, Field } from '../../components/ui';
import { isBlank } from '../../lib/settingsForm';
import SettingsCard, { useSettingsCard } from './SettingsCard';

/**
 * Who the professional is: name and phone.
 *
 * Email is shown and not editable, because it identifies the account and is
 * what claims and password resets match on; changing it belongs in a flow that
 * verifies the new address.
 */
const DetailsTab = () => {
  const { profile, refresh } = useSession();
  const { form, change, save, card } = useSettingsCard('details', {
    first_name: profile.first_name ?? '',
    last_name: profile.last_name ?? '',
    phone: profile.phone ?? '',
  });

  const onSave = () => save(async (typed) => {
    if (isBlank(typed.first_name) || isBlank(typed.last_name)) return t('mySettings.nameRequired');
    const stored = {
      first_name: typed.first_name.trim(),
      last_name: typed.last_name.trim(),
      phone: typed.phone.trim(),
    };
    const { error } = await supabase.from('therapists')
      .update({ ...stored, phone: stored.phone || null })
      .eq('id', profile.id);
    if (error) return error.message;
    // The header shows the name the session holds.
    refresh();
    return { saved: stored };
  });

  return (
    <SettingsCard title={t('profile.contact')} card={card} onSave={onSave}>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label={t('register.firstName')} required>
          <Input value={form.first_name} onChange={(event) => change({ first_name: event.target.value })} />
        </Field>
        <Field label={t('register.lastName')} required>
          <Input value={form.last_name} onChange={(event) => change({ last_name: event.target.value })} />
        </Field>
        <Field label={t('register.phone')}>
          <Input type="tel" value={form.phone} onChange={(event) => change({ phone: event.target.value })} />
        </Field>
        <Field label={t('auth.email')} hint={t('profile.emailFixed')}>
          <Input value={profile.email ?? ''} disabled />
        </Field>
      </div>
    </SettingsCard>
  );
};

export default DetailsTab;
